import React, { useEffect, useState } from "react";
import "./../../css/table.css";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";

const Customers = () => {
  const [users, setUsers] = useState([]);
  const [admissioners, setAdmissioners] = useState([]);
  const [admission, setAdmission] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getAdmissioners();
    getClients();
  }, []);

  const changeHandler = (e) => {
    setAdmission(e.target.value);
  };

  const getAdmissioners = () => {
    axios
      .get("https://arianaapp.arianaapply.com/panel/show-admissioner")
      .then((res) => {
        console.log(res)
        setAdmissioners(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getClients = () => {
    axios
      .get("https://arianaapp.arianaapply.com/panel/show-client-admission")
      .then((res) => {
        console.log(res)
        setUsers(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const setAdmissioner = (user_id) => {
    axios
      .post(`https://arianaapp.arianaapply.com/panel/assign-admissioner-client`, {
        admissioner_id: admission,
        client_id: user_id,
      })
      .then((res) => {
        console.log(res)
        Swal.fire({
          title: "ثبت شد",
          icon: "success",
        });
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  return (
    <div className="index">
      {loading === false ? (
        <div className="table">
          <table>
            <thead>
              <tr>
              <td>#</td>
                <td>نام مشتری</td>
                <td>انتخاب ادمیشن</td>
              </tr>
            </thead>
            <tbody>
              {users.map((user, i) => (
                <tr key={user._id}>
                                          <td>{i}</td>
                  <td>{user.name}</td>
                  <td className="td-add">
                    <select onChange={changeHandler} value={admission}>
                      <option value="">انتخاب کنید</option>
                      {admissioners.map((ad) => (
                        <option value={ad._id} key={ad._id}>
                          {ad.name}
                        </option>
                      ))}
                    </select>
                    <button
                      className="role-btn"
                      onClick={() => setAdmissioner(user._id)}
                    >
                      <FontAwesomeIcon color="#6366f1" icon={faCheck} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <Spinner animation="border" variant="primary" />
      )}
    </div>
  );
};

export default Customers;
